// extracted by mini-css-extract-plugin
module.exports = {"section":"SearchGenresThemesList__section","content":"SearchGenresThemesList__content"};